import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
type GuaranteeSealProps = {
  className?: string;
};

/** Golden 7-day satisfaction guarantee seal. */
export function GuaranteeSeal({
  className = ''
}: GuaranteeSealProps) {
  return <div className={`relative flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-dashed border-gold bg-white text-center shadow-md sm:h-32 sm:w-32 ${className}`} data-id="element-130" data-mp="24raevnal04h7">
      <ShieldCheckIcon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-131" data-mp="2whez9lyccrif" />
      <span className="mt-0.5 font-serif text-xl font-bold leading-none text-gold sm:text-2xl" data-id="element-132" data-mp="31ex8zek6narh">7 días</span>
      <span className="mt-1 px-2 text-[9px] font-bold uppercase leading-tight tracking-wide text-ink/60 sm:text-[10px]" data-id="element-133" data-mp="2nffced0nat7k">
        Garantía de satisfacción
      </span>
    </div>;
}